import { api } from "./api";

// Catálogo de documentos da ficha (o checklist do candidato lê daqui).
export const listarTiposDocumento = (incluirInativos = true) =>
  api.get(`/tipo-documento/listar?incluirInativos=${incluirInativos}`);
export const gruposTipoDocumento = () => api.get("/tipo-documento/grupos");
export const salvarTipoDocumento = (dto) => api.post("/tipo-documento/salvar", dto);
export const ativarTipoDocumento = (id, ativo) => api.post(`/tipo-documento/${id}/ativo?ativo=${ativo}`);
export const excluirTipoDocumento = (id) => api.post(`/tipo-documento/excluir/${id}`);
export const ordenarTiposDocumento = (ids) => api.post("/tipo-documento/ordenar", { Ids: ids });
